import { render, staticRenderFns } from "./EmployeeAssignmentDetail.vue?vue&type=template&id=bcbbf228&scoped=true"
import script from "./EmployeeAssignmentDetail.vue?vue&type=script&lang=js"
export * from "./EmployeeAssignmentDetail.vue?vue&type=script&lang=js"
import style0 from "./EmployeeAssignmentDetail.vue?vue&type=style&index=0&id=bcbbf228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbbf228",
  null
  
)

export default component.exports